module.exports = __webpack_public_path__ + "static/media/SymptomChecker@2x.e5961ee1.jpg";